// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3SPHA","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2Ztx7"};